export default __webpack_public_path__ + "static/media/top-background-animation.dd04d109.jpg";